<template>
  <div class="history-page-container">
    <exam-header :canClickLogo="true"></exam-header>
    <div class="history-list-main">
      <div class="page-hd">
        <div class="page-title">
          <div class="back" @click="goBack"><i class="el-icon-arrow-left"></i>返回</div>
          <div class="title">我的考试记录</div>
        </div>
        <div class="page-filter-form">
          <el-form :model="filterForm" :inline="true" class="filter-form">
            <el-form-item label="考试名称：" class="examName-form-item">
              <el-input v-model="filterForm.roundName"></el-input>
            </el-form-item>
            <el-form-item label="开始考试时间：">
              <el-date-picker
                  v-model="daterange"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始时间" end-placeholder="时间区间">
              </el-date-picker>
            </el-form-item>
            <el-form-item class="form-btns">
              <el-button type="primary" @click="handleQuery" class="search-btn">查询</el-button>
              <el-button @click="handleReset" class="reset-btn">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <template v-if="paperList.length > 0">
        <div class="list-main">
          <div class="list-item-warp">
            <div class="paper-list-item" v-for="(item,index) in paperList" :key="index">
              <div class="paper-info">
                <div class="list-item-title"><span class="ic_paper"/>{{item.roundName}}</div>
                <div class="paper-date">开始考试时间: {{item.startTime | formatTime}} &nbsp;&nbsp;<template v-if="item.status ===1">交卷时间: {{item.endTime | formatTime}}</template></div>
              </div>
              <div class="btn" v-if="item.canCheckGrade" @click="handleShowGrade(item)">查看成绩</div>
            </div>
          </div>

        </div>
        <div class="pagination-section">
          <div class="pagination-info">
            总共{{ total }}个项目
          </div>
          <div class="pagination-controls">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-size="pageSize"
                layout="prev, pager, next,jumper"
                :total="total">
            </el-pagination>
          </div>
        </div>
      </template>
      <div class="list-main" v-else>
        <div class="list-main_empty">
          <img src="@/common/images/empty_img.png" alt=""/>
          <p>暂无考试记录</p>
        </div>
      </div>
    </div>
    <!-- 成绩弹窗 -->
    <exam-grade-modal
        v-if="gradeModalConfig.show"
        :record = "gradeModalConfig.record"
        @close="handleGradeModalClose"
    ></exam-grade-modal>
  </div>
</template>
<script>
import ExamHeader from "@/components/examHeader.vue";
import {getExamHistoryList} from "@/api/qzStudent";
import {
  Button,
  Input,
  Message,
  Form,
  FormItem,
  Table,
  TableColumn,
  DatePicker,
  Pagination,
  Loading
} from "element-ui";
import dayjs from "dayjs";
import {getSystemTime} from "@/api/api";
import ExamGradeModal from "@/pages/student/components/examGradeModal.vue";
export default {
  components: {
    'el-pagination':Pagination,
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-date-picker': DatePicker,
    ExamHeader,
    ExamGradeModal
  },
  data() {
    return {
      total:0,
      daterange:'',
      pageNo:1,
      pageSize:20,
      loading: false,
      paperList:[],
      filterForm:{
        roundName:'',
        startTime:null,
        endTime:null,
      },
      gradeModalConfig: {
        show: false,
      },
    }
  },
  filters: {
    formatTime(time) {
      return time ? dayjs(time).format('YYYY年M月D日 HH:mm:ss') : '';
    }
  },
  created() {
    this.getPaperList();
  },
  methods :{
    handleShowGrade(userExamInfo) {
      this.gradeModalConfig = {
        show: true,
        record: userExamInfo,
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    handleGradeModalClose() {
      this.gradeModalConfig = {
        show: false
      }
    },
    handleQuery() {
      // 处理日期范围
      if (this.daterange && this.daterange.length === 2) {
        this.filterForm.startTime = new Date(this.daterange[0]).valueOf();
        this.filterForm.endTime = new Date(this.daterange[1]).valueOf();
      } else {
        this.filterForm.startTime = null;
        this.filterForm.endTime = null;
      }
      this.pageNo = 1;
      this.getPaperList();
    },
    handleReset() {
      this.filterForm = {
        roundName: '',
        startTime: null,
        endTime: null,
      };
      this.daterange = [];
      this.pageNo = 1;
      this.getPaperList();
    },
    handleCurrentChange (val) {
      this.pageNo = val;
      this.getPaperList();
    },
    handleSizeChange (size) {
      this.pagination.pageSize = size;
      this.pagination.pageNo = 1;
      this.getPaperList(this.filterForm);
    },
    async getPaperList () {
      this.loading = true;
      const params = {
        ...this.filterForm,
        pageNo: this.pageNo - 1,
        pageSize: this.pageSize
      };
      const now = await getSystemTime();
      getExamHistoryList(params).then(res=>{
        if(res.code === 200 && res.body?.userExamRounds){
          this.total = res.body.totalCount || 0;
          this.paperList = res.body?.userExamRounds.map(item => {
            const {releaseResultTime,markStatus} = item;
            if(now >= releaseResultTime && markStatus === 2){
              item.canCheckGrade = true;
            }
            return item
          })
        }
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>
<style scoped lang="less">
.history-page-container{
  background: #EDE4DA;
  min-height: 100%;
  padding-top: 96px;
  padding-bottom: 56px;
  box-sizing: border-box;
  .history-list-main{
    width: 1200px;
    border-radius: 20px;
    margin: 0 auto;
    background: rgba(247, 246, 245, 1);
    min-height: calc(100vh - 160px);
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    .page-hd{
      display: flex;
      background-color: #fff;
      flex-direction: column;
      text-align: left;
      padding: 36px 40px 40px;
      box-sizing: border-box;
      .page-title{
        margin-bottom: 36px;
        position: relative;
        font-weight: 600;

        .title{
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: rgba(0, 0, 0, 0.9);
        }
        .back{
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          font-size: 16px;
          cursor: pointer;
          color: #4E5969;
          i{
            color: #4E5969;
            margin-right: 8px;
          }
        }
      }
      .page-filter-form{
        flex: 1;
        text-align: left;
        position: relative;
        .examName-form-item{
          margin-right: 20px;
        }
        .el-form-item{
          margin-bottom: 0;
        }
        .form-btns{
          position: absolute;
          right: 0;
          top: 0;
          .el-button{
            height: 36px;
            line-height: 36px;
            text-align: center;
            border-radius: 90px;
            border: none;
            outline: none;
            font-size: 14px;
            font-weight: 500;
            padding: 0 24px;
            &.search-btn{
              background: #E60012;
              color: #fff;
            }
            &.reset-btn{
              background: #F2F3F5;
              color: #000000E5;
            }
          }
        }
      }
    }
    .list-main{
      width: 100%;
      padding: 24px 40px 40px;
      box-sizing: border-box;
      background: rgba(247, 246, 245, 1);
      position: relative;
      max-height: 550px;
      overflow-y: auto;
      .list-main_empty {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 30px;
        img{
          width: 180px;
          height: 180px;
        }
        p{
          color: #000000;
          font-size: 18px;
          margin-top: 16px;
          font-weight: 500;
        }
      }
      .paper-list-item{
        background: #FFFFFF;
        border: 1px solid #E5E6EB;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 83px;
        padding: 0 24px;
        box-sizing: border-box;
        margin-bottom: 12px;
        &:last-child{
          margin-bottom: 0;
        }
        .paper-info{
          .list-item-title{
            color: #1D2129;
            display: flex;
            font-size: 18px;
            font-weight: 500;
            margin-bottom: 4px;
            span{
              width: 24px;
              height: 24px;
              background: url("@/common/images/student/ic_edit.png") center / contain no-repeat;
              margin-right: 4px;
            }
          }
          .paper-date{
            color: #86909C;
            font-weight: 400;
            text-align: left;
          }
        }
        .btn{
          background: #000000;
          color: #fff;
          height: 34px;
          width: 102px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          font-weight: 500;
          border-radius: 90px;
        }
      }
    }
    .pagination-section {
      width: 100%;
      max-width: 1200px;
      display: flex;
      justify-content: flex-end;
      box-sizing: border-box;
      align-items: center;
      padding: 16px 24px;
      .pagination-info {
        font-size: 14px;
        color: #000;
        margin-right: 12px;
      }
      .pagination-controls {
        display: flex;
        align-items: center;
        .el-pagination {
          margin-right: 0;
          .el-pager li {
            background: none;
            &.active {
              background: #E60012;
              color: #fff;
              border-color: #E60012;
            }
          }
        }

        .page-jump {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #606266;

          span {
            margin: 0 4px;
          }
        }
      }
    }
  }
}
</style>
<style>
.page-filter-form{
  .el-form-item__label {
    font-size: 16px;
    font-weight: bold;
    padding: 0 4px 0 0;
    margin-right: 4px;
  }
  .el-date-editor .el-range__icon{
    display: flex;
    align-items: center;
  }
  .el-range-separator{
    display: flex;
    align-items: center;
  }
  .description-input{
    .el-input__inner{
      width: 120px;
    }
  }
  .date-input{
    .el-input__inner{
      width: 280px;
    }
  }
  .el-input__inner{
    height: 40px;
    line-height: 40px;
  }
}
.history-list-main{
  .el-pagination {
    .el-pager li {
      min-width: 32px;
      height: 32px;
      font-size: 14px;
      color: #000;
      line-height: 30px;
      border-radius: 4px;
      margin: 0 2px;
      background: none;
      &.active{
        color: #E60012;
      }
    }

    .btn-prev, .btn-next {
      width: 32px;
      height: 32px;
      line-height: 30px;
      border-radius: 4px;
      background: none;
    }
  }
}
</style>